import { useState } from "react"

import DealCard from "./DealCard"
import ProductCard from "./ProductCard"

export default function Collapse({ type, title, items }) {
  const [collapse, setCollapse] = useState(false)

  return (
    <>
      <div className="d-flex gap-2 justify-content-between align-items-center list-group-item-cart" onClick={() => setCollapse(!collapse)}>
        <p className="text-body-emphasis fw-bold m-0">{title}</p>
        <i className={`fs-10 bi bi-chevron-${collapse ? 'up' : 'down'}`}></i>
      </div>
      <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-6 g-3">
        {!collapse && items.map((item) => type === "deal" ? <DealCard key={item.id.toString()} item={item} /> : <ProductCard key={item.id.toString()} item={item} />)}
      </div>
    </>
  )
}
